// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShortcutsMenuWrapper_wrapper__U2ES-","wrapperInner":"ShortcutsMenuWrapper_wrapperInner__3kB17"};